import { render, staticRenderFns } from "./Bval.vue?vue&type=template&id=712fcd88&scoped=true&"
import script from "./Bval.vue?vue&type=script&lang=js&"
export * from "./Bval.vue?vue&type=script&lang=js&"
import style0 from "./Bval.vue?vue&type=style&index=0&id=712fcd88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712fcd88",
  null
  
)

export default component.exports